
import Vue from 'vue';
import Router from 'vue-router';
import $vuex from '@/store'
import login from './login'

Vue.use(Router);
// 路由详情
const routes = [
  {
    path: '/',
    component: () => import('@/layouts/BasicLayout'),
    meta: {title:'首页'},
    children: [
      {
        path: 'exception/404',
        component: () => import(/* webpackChunkName: "exception-404" */ '@/pages/exception/404')
      },
      {
        path: 'system/log',
        component: () => import(/* webpackChunkName: "exception-403" */ '@/pages/system/SysLogList'),
        meta: {title:'系统日志'}
      },
      {
        path: 'system/setting',
        component: () => import(/* webpackChunkName: "exception-403" */ '@/pages/system/SettingSite'),
        meta: {title:'系统设置'}
      },
      {
        path: 'app/package',
        component: () => import(/* webpackChunkName: "admin-app-package" */ '@/pages/app/AdminAppPackage'),
        meta: {title:'安装包管理'}
      },
      {
        path: 'system/params',
        component: () => import(/* webpackChunkName: "exception-403" */ '@/pages/system/ParamList'),
        meta: {title:'参数管理'}
      },
      {
        path: 'system/backup',
        component: () => import(/* webpackChunkName: "system-backup" */ '@/pages/system/SystemBackup'),
        meta: {title:'系统备份'}
      },
      {
        path: 'system/open-token',
        component: () => import(/* webpackChunkName: "open-token-list" */ '@/pages/system/OpenTokenList'),
        meta: {title:'访问令牌'}
      },
      {
        path: 'system/role',
        component: () => import(/* webpackChunkName: "exception-403" */ '@/pages/system/RoleList'),
        meta: {title:'角色管理'},
        children: [
          {
            path: ':id/manage_members/',
            component: () => import(/* webpackChunkName: "exception-403" */ '@/pages/system/ManageMembers'),
            meta: {title:'角色成员管理'}
          }
        ] 
      },
      {
        path: 'cms/blog',
        component: () => import(/* webpackChunkName: "article-list" */ '@/pages/cms/ArticleList'),
        meta: {title:'博客管理'},
        children: [
          {
            path: 'create',
            component: () => import(/* webpackChunkName: "article-create" */ '@/pages/cms/CreateEdit'),
            meta: {title:'添加博客'},
          },
          {
            path: 'edit/:id',
            component: () => import(/* webpackChunkName: "article-edit" */ '@/pages/cms/CreateEdit'),
            meta: {title:'编辑博客'},
          }
        ]
      },
      {
        path: 'cms/article',
        component: () => import(/* webpackChunkName: "article-list" */ '@/pages/cms/ArticleList'),
        meta: {title:'新闻管理'},
        children: [
          {
            path: 'create',
            component: () => import(/* webpackChunkName: "article-create" */ '@/pages/cms/CreateEdit'),
            meta: {title:'添加新闻'},
          },
          {
            path: 'edit/:id',
            component: () => import(/* webpackChunkName: "article-edit" */ '@/pages/cms/CreateEdit'),
            meta: {title:'编辑新闻'},
          }
        ]
      },
      {
        path: 'cms/case',
        component: () => import(/* webpackChunkName: "case-list" */ '@/pages/cms/ArticleList'),
        meta: {title:'案例管理'},
        children: [
          {
            path: 'create',
            component: () => import(/* webpackChunkName: "case-create" */ '@/pages/cms/CreateEdit'),
            meta: {title:'添加案例'},
          },
          {
            path: 'edit/:id',
            component: () => import(/* webpackChunkName: "case-edit" */ '@/pages/cms/CreateEdit'),
            meta: {title:'编辑案例'},
          }
        ]
      },
      {
        path: 'cms/qa-category',
        component: () => import(/* webpackChunkName: "qa-category-list" */ '@/pages/cms/QaCategoryList'),
        meta: {title:'问答分类'},
      },
      {
        path: 'cms/question',
        component: () => import(/* webpackChunkName: "qa-list" */ '@/pages/cms/QaList'),
        meta: {title:'问答管理'},
        children: [
          {
            path: 'create',
            component: () => import(/* webpackChunkName: "qa-create" */ '@/pages/cms/QaEdit'),
            meta: {title:'添加问答'},
          },
          {
            path: ':id/edit',
            component: () => import(/* webpackChunkName: "qa-edit" */ '@/pages/cms/QaEdit'),
            meta: {title:'编辑问答'},
          }
        ]
      },
      {
        path: 'cms/inquiry',
        component: () => import(/* webpackChunkName: "inquiry-list" */ '@/pages/cms/InquiryList'),
        meta: {title:'咨询管理'},
      },
      {
        path: 'cms/category',
        component: () => import(/* webpackChunkName: "category-list" */ '@/pages/cms/CategoryList'),
        meta: {title:'分类管理'},
      },
      {
        path: 'cms/category/:id',
        component: () => import(/* webpackChunkName: "category-node" */ '@/pages/cms/CategoryList'),
        meta: {title:'子分类'},
      },
      {
        path: 'customer/list',
        component: () => import(/* webpackChunkName: "customer-list" */ '@/pages/customer/CustomerList'),
        meta: {title:'客户管理'},
      },
      {
        path: 'customer/order',
        component: () => import(/* webpackChunkName: "customer-order" */ '@/pages/customer/CustomerOrderList'),
        meta: {title:'客户订单'},
      },
      {
        path: 'system/notification',
        component: () => import(/* webpackChunkName: "notification-list" */ '@/pages/system/NotificationList'),
        meta: {title:'通知中心'},
      },
      {
        path: 'customer/chat',
        component: () => import(/* webpackChunkName: "chat-workbench" */ '@/pages/customer/ChatWorkbench'),
        meta: {title:'智能客服'},
      },
      {
        path: 'customer/order/:id/customer_order_item',
        component: () => import(/* webpackChunkName: "customer-order-item" */ '@/pages/customer/CustomerOrderItemList'),
        meta: {title:'客户订单详情'},
        children: [
          {
            path: ':order_item_id/customer_order_item_craft_detail',
            component: () => import(/* webpackChunkName: "customer-order-item-craft-detail" */ '@/pages/customer/CustomerOrderItemCraftDetailList'),
            meta: {title:'订单项工艺详情'},
          },
          {
            path: ':order_item_id/:follow_craft_id/customer_order_item_craft_detail',
            component: () => import(/* webpackChunkName: "customer-order-item-craft-detail" */ '@/pages/customer/CustomerOrderItemCraftDetailList'),
            meta: {title:'订单项工艺详情'},
          }
        ]
      },
      {
        path: 'customer/order-follow/:id',
        component: () => import(/* webpackChunkName: "customer-order-follow" */ '@/pages/customer/CustomerOrderFollow'),
        meta: {title:'订单跟进'},
      },
      {
        path: 'customer/group',
        component: () => import(/* webpackChunkName: "customer-group" */ '@/pages/customer/CustomerGroup'),
        meta: {title:'客户分组'},
      },
      {
        path: 'customer/coupon-rule',
        component: () => import(/* webpackChunkName: "coupon-rule-list" */ '@/pages/customer/CouponRuleList'),
        meta: {title:'优惠券规则'},
      },
      {
        path: 'customer/coupon',
        component: () => import(/* webpackChunkName: "customer-coupon-list" */ '@/pages/customer/CustomerCouponList'),
        meta: {title:'用户优惠券'},
      },
      {
        path: 'customer/:id/address',
        component: () => import(/* webpackChunkName: "customer-address" */ '@/pages/customer/CustomerAddressList'),
        meta: {title:'客户地址'},
      },
      {
        path: 'customer/:id/file',
        component: () => import(/* webpackChunkName: "customer-file" */ '@/pages/customer/CustomerFileList'),
        meta: {title:'客户文件'},
      },
      {
        path: 'customer/profile',
        component: () => import(/* webpackChunkName: "customer-group" */ '@/pages/customer/Profile'),
        meta: {title:'客户分组'},
      },
      {
        path: 'customer/:id/order',
        component: () => import(/* webpackChunkName: "customer-order" */ '@/pages/customer/CustomerOrderList'),
        meta: {title:'客户订单'},
      },
      {
        path: 'express/company',
        component: () => import(/* webpackChunkName: "express-list" */ '@/pages/express/ExpressList'),
        meta: {title:'快递公司'},
      },
      {
        path: 'express/:id/area_cost',
        component: () => import(/* webpackChunkName: "arrive-address" */ '@/pages/express/ArriveAddressCostList'),
        meta: {title:'区域费用'},
      },
      {
        path: 'express/:id/baf_cost',
        component: () => import(/* webpackChunkName: "arrive-address" */ '@/pages/express/ArriveAddressBafCostList'),
        meta: {title:'附加费用'},
      },
      {
        path: 'express/area',
        component: () => import(/* webpackChunkName: "craft-colour" */ '@/pages/express/ArriveAddressList'),
        meta: {title:'可达地址'},
      },
      {
        path: 'express/package',
        component: () => import(/* webpackChunkName: "craft-colour" */ '@/pages/express/PackageList'),
        meta: {title:'包裹管理'},
      },
      {
        path: 'express/:id/address_node',
        component: () => import(/* webpackChunkName: "craft-colour" */ '@/pages/express/AddressNodeList'),
        meta: {title:'地址节点'},
      },
      {
        path: 'craft/list',
        component: () => import(/* webpackChunkName: "craft-colour" */ '@/pages/craft/CraftList'),
        meta: {title:'工艺管理'},
      },
      {
        path: 'craft/:id/category',
        component: () => import(/* webpackChunkName: "craft-colour" */ '@/pages/craft/CraftCategoryList'),
        meta: {title:'工艺分类'},
      },
      {
        path: 'craft/category/:id/material',
        component: () => import(/* webpackChunkName: "craft-colour" */ '@/pages/craft/CraftCategoryMaterialList'),
        meta: {title:'材料管理'},
      },
      {
        path: 'craft/category/material/:id/material_color',
        component: () => import(/* webpackChunkName: "craft-colour" */ '@/pages/craft/MaterialColourList'),
        meta: {title:'材料颜色'},
      },
      {
        path: 'craft/category/material/:id/material_duration',
        component: () => import(/* webpackChunkName: "craft-colour" */ '@/pages/craft/MaterialDurationList'),
        meta: {title:'材料时长'},
      },
      {
        path: 'craft/category/material/:id/material_follow_craft',
        component: () => import(/* webpackChunkName: "craft-colour" */ '@/pages/craft/MaterialFollowCraftList'),
        meta: {title:'后处理工艺'},
      },
      {
        path: 'craft/follow_craft',
        component: () => import(/* webpackChunkName: "craft-colour" */ '@/pages/craft/FollowCraftList'),
        meta: {title:'后处理工艺'},
      }
    ]
  },
  {
    path: '/',
    component: () => import('@/layouts/PassportLayout'),
    children: [
      login, // 登录
    ]
  },
  {
    path:"*",
    redirect:'/exception/404',
    // component: () => import('@/pages/exception/404')
  }
]

// 实例化
const router = new Router({
  mode: 'history', // 使用 history 模式
  base: process.env.BASE_URL,
  routes,
  // 添加安全的滚动行为
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

// 路由钩子
router.beforeEach((to, from, next) => {
  // 添加安全检查，防止权限策略违规
  try {
    ifLogin(to, next)
    handelSiderMenu(to)
    next()
  } catch (error) {
    console.error('路由守卫错误:', error)
    next()
  }
});

// 路由后置守卫，清理可能的异步操作
router.afterEach(() => {
  // 清理可能的异步操作
  setTimeout(() => {
    if (window.Vue && window.Vue.prototype.$children) {
      window.Vue.prototype.$children.forEach(child => {
        if (child.submitLoading !== undefined) {
          child.submitLoading = false
        }
        if (child.loadingStaus !== undefined) {
          child.loadingStaus = false
        }
      })
    }
  }, 0)
})

let handelSiderMenu =  (to) => {
  try {
    $vuex.commit('handleRoutePath', to.path)
  } catch (error) {
    console.error('处理侧边栏菜单错误:', error)
  }
}

let ifLogin = (to, next) => {
  try {
    let userInfo = JSON.parse(localStorage.getItem('user_info'))
    // 判断是否是登录页
    let idx = to.path.indexOf('login') != -1
     // 没有userInfo 且 不是login 页 => 登录页
    if (!userInfo && !idx) {
      next('/login')
    }
    // 有userinfo 且 是login 页 => 首页
    if (idx && userInfo) {
      next('/')
    }
  } catch (error) {
    console.error('登录检查错误:', error)
    // 出错时跳转到登录页
    if (to.path.indexOf('login') === -1) {
      next('/login')
    }
  }
}

export default router
